<template>
  <onboarding-container :width="1000">
    <h2 class="onboarding--heading">Your Account is
      <template v-if="isAccountProvisioning">Getting</template>
      Ready
    </h2>
    <p v-if="isAccountProvisioning" class="onboarding--text">We need a few moments to set everything up. While you wait
      make sure you take advantage
      of the ways we keep in touch.</p>

    <div class="flex my-200" style="justify-content: space-evenly">
      <div>
        <a
          href="https://calendly.com/forefrontcrm/onboarding"
          target="_blank"
        >
          <img src="/images/onboarding.png" alt="Schedule Onboarding"/>
        </a>

        <a
          class="onboarding_button button is-primary is-outlined"
          href="https://calendly.com/forefrontcrm/onboarding"
          target="_blank"
        >Schedule a Meeting</a>
      </div>

      <div class="mx-200">
        <a
          href="https://www.addevent.com/event/JF6239395"
          target="_blank"
        >
          <img src="/images/bi-weekly-qa.png" alt="Forefront Q&A Session"/>
        </a>

        <a
          title="Add to Calendar"
          class="onboarding_button button is-primary is-outlined"
          data-id="JF6239395"
          href="https://www.addevent.com/event/JF6239395"
          target="_blank"
          rel="nofollow"
        >Add to Calendar</a>
      </div>

      <div>
        <a
          href="https://www.facebook.com/groups/454827795099299"
          target="_blank"
        >
          <img src="/images/fb-community.png" alt="Join our Facebook Group"/>
        </a>

        <a
          class="onboarding_button button is-primary is-outlined"
          href="https://www.facebook.com/groups/454827795099299"
          target="_blank"
        >Join Our Facebook Group</a>
      </div>
    </div>

    <h3 class="onboarding--subheading text-center">If you need anything... reach out to support@forefrontcrm.com or
      visit <a href="https://help.forefrontcrm.com/" target="_blank">our help site</a></h3>

    <p v-if="!hasWhiteGloveService" class="onboarding--subheading text-center">Also take a look at our <a
      href="https://help.forefrontcrm.com/knowledge-base/uncategorized/onboarding-checklist/"
      target="_blank"
    >12-step checklist</a> to kickstart your journey with Forefront CRM</p>


    <div class="flex flex-vertical-center flex-end mt-300 mb-100">
      <p v-if="isAccountProvisioning" class="mr-200 is-italic">Please wait while your account is provisioning</p>
      <div v-else-if="!hasWhiteGloveService" class="mr-200">
        <button-outlined
          @click="goToIntegrations"
          size=""
        >Set Up Integrations
        </button-outlined>
      </div>

      <button-default
        @click="goToAccount"
        size=""
        :disabled="isAccountProvisioning"
      >Go to your Forefront account
      </button-default>
    </div>
  </onboarding-container>
</template>

<script>
import {defineComponent} from 'vue'
import OnboardingContainer from "./component/OnboardingContainer.vue";
import api from "../../api";
import {SnackbarProgrammatic as Snackbar} from "buefy";

export default defineComponent({
  name: "OnboardingProvisioningPage",
  metaInfo: {
    title: "Provisioning Account"
  },
  components: {OnboardingContainer},
  beforeRouteEnter(to, from, next) {

    next(vm => {
      if(vm.$store.state.onboarding.onboarding.chosen_integrations) {
        next({name: 'onboarding-wizard-3'})
      } else {
        next()
      }
    })
  },
  data() {
    return {
      isAccountProvisioning: true
    }
  },
  mounted() {
    if(!this.onboarding.is_provisioned) {
      const accountId = this.$store.getters.account.id;
      const provisionData = this.$store.state.onboarding.provisionData;

      const data = {
        statuses: [],
        contact_types: [],
        campaigns: provisionData.campaigns,
        fus_templates: provisionData.followUps,
        user_invites: provisionData.users,
      }

      provisionData.statuses.Contacting.forEach(status => data.statuses.push(status));
      provisionData.statuses.Active.forEach(status => data.statuses.push(status));
      provisionData.statuses.FollowUp.forEach(status => data.statuses.push(status));
      provisionData.statuses.Completed.forEach(status => data.statuses.push(status));
      provisionData.statuses.Dead.forEach(status => data.statuses.push(status));
      provisionData.statuses.NonLead.forEach(status => data.statuses.push(status));

      provisionData.types.Seller.forEach(type => data.contact_types.push(type));
      provisionData.types.Other.forEach(type => data.contact_types.push(type));

      api.accounts.provisionAccount(accountId, data).then((response) => {
          this.$store.commit('onboarding/updateOnboarding', response.data);
          this.isAccountProvisioning = false
      });
    } else {
      this.isAccountProvisioning = false;
    }
  },
  computed: {
    onboarding() {
      return this.$store.state.onboarding.onboarding;
    },
    hasWhiteGloveService() {
      return this.$store.state.onboarding.hasWhiteGloveService;
    },
  },
  methods: {
    goToAccount() {
      api.onboarding.markComplete(this.onboarding.id).then((response) => {
        this.$store.commit('onboarding/updateOnboarding', response.data);
        this.$router.push({name: 'pipeline'})
      }).catch(() => {
        Snackbar.open({
          message: 'Your account was not provisioned. Please contact support@forefrontcrm.com so we can get this sorted out.',
          type: 'is-danger',
          position: 'is-bottom',
          indefinite: true
        });
      })
    },
    goToIntegrations() {
      this.$router.push({name: 'onboarding-wizard-2'})
    }
  },
})
</script>

<style scoped lang="scss">
.onboarding {
  &--heading {
    margin: 1rem 0;
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
  }

  &--content {
    margin-top: 2rem;
  }

  &--text {
    max-width: 800px;
    margin: 0 auto 10px;
    font-size: 1.25rem;
    line-height: 1.3;
    text-align: center;
  }

  &--subheading {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    font-weight: bold;
  }
}

.onboarding_button {
  display: block;
  margin-top: 8px;
  line-height: 38px;
}
</style>
